<template>
  <div>
    <h3>优惠券使用明细</h3>
    <el-form :inline="true" size="mini">
      <el-form-item label="优惠券id">
        <el-input v-model="filter.couponId" placeholder="优惠券id"></el-input>
      </el-form-item>
      <el-form-item label="优惠券状态">
        <el-select v-model="filter.status">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(label, value) in map.coupon.status"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="有效时间">
        <el-date-picker
          v-model="filter.effectiveTime"
          type="date"
          placeholder="开始时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          :editable="false"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.expireTime"
          type="date"
          placeholder="结束时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          :editable="false"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="关联用户昵称">
        <el-input
          v-model="filter.nickname"
          placeholder="关联用户昵称"
        ></el-input>
      </el-form-item>
      <el-form-item label="购买类型">
        <el-select v-model="filter.forPeople">
          <el-option
            v-for="(label, value) in map.coupon.forPeopleStatus"
            :key="value"
            :label="label"
            :value="Number(value)"
          ></el-option>
          <el-option label="非购买" value=""></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetch(1)" size="mini">查询</el-button>
        <el-button type="primary" @click="exportExcel" size="mini"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="couponId" width="200px" label="优惠券id">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">{{
            scope.row.couponId
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型">
        <template slot-scope="scope">{{
          map.coupon.type[scope.row.type]
        }}</template>
      </el-table-column>
      <el-table-column prop="type" label="购买类型">
        <template slot-scope="scope">{{
          scope.row.forPeople == 6 ? "购买" : "非购买"
        }}</template>
      </el-table-column>
      <el-table-column
        prop="thresholdAmount"
        label="门槛金额"
      ></el-table-column>
      <el-table-column prop="amount" label="额度"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">{{
          map.coupon.status[scope.row.status]
        }}</template>
      </el-table-column>
      <el-table-column prop="convertCode" width="160px" label="兑换码">
      </el-table-column>
      <el-table-column
        prop="billId"
        width="140px"
        label="结算单id"
      ></el-table-column>
      <el-table-column
        prop="effectiveTime"
        width="160px"
        label="生效时间"
      ></el-table-column>
      <el-table-column
        prop="expireTime"
        width="160px"
        label="到期时间"
      ></el-table-column>
      <el-table-column prop="nickname" label="关联用户"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :disabled="scope.row.status !== 1"
                :command="{ action: 'delete', data: scope.row }"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";

const { coupon } = api;

export default {
  name: "couponDetail",
  data() {
    return {
      map,
      filter: {
        couponId: "",
        nickname: "",
        status: "",
        effectiveTime: "",
        expireTime: "",
        activityId: "",
      },
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
      isSubmiting: false,
    };
  },
  components: {},
  computed: {
    activityId() {
      return this.$route.query.id || "";
    },
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  created() {
    this.filter.activityId = this.activityId;
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;
      let {
        couponId,
        nickname,
        status,
        effectiveTime,
        expireTime,
        activityId,
        forPeople,
      } = this.filter;
      let obj = {
        pageNum: pageNum,
        limit: limit,
        couponId,
        nickname,
        status,
        effectiveTime,
        expireTime,
        activityId,
        forPeople,
      };

      let res = await coupon.coupons(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      switch (action) {
        case "delete":
          this.deleteCoupon(data);
          break;
        default:
      }
    },
    async deleteCoupon(couponData) {
      this.$confirm("删除后优惠券变为已过期状态", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        type: "warning",
      })
        .then(async () => {
          if (this.isSubmiting) return false;
          this.isSubmiting = true;

          let obj = {
            couponId: couponData.couponId,
            status: 3,
          };
          let {
            data: { code, data },
          } = await coupon.updateStatus(obj);
          if (code == 200) {
            this.$message.success("操作成功");
            this.fetch();
          }
          this.isSubmiting = false;
        })
        .catch((e) => {
          console.log(e);
          this.isSubmiting = false;
          if (e === "cancel") {
            this.$message({
              type: "info",
              message: "已取消",
            });
          } else {
            this.$message({
              type: "error",
              message: "操作失败",
            });
          }
        });
    },
    async exportExcel() {
      this.loading = true;
      let resp = await coupon.exportExcel(this.filter);
      let objectUrl = URL.createObjectURL(new Blob([resp.data]));
      let link = document.createElement("a");
      link.download = decodeURIComponent("优惠券列表.xlsx");
      link.href = objectUrl;
      link.click();
      this.loading = false;
    },
    goDetail(row) {
      this.$router.push({
        path: "/coupon/activity",
        query: { couponActivityId: row.couponActivityId },
      });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/coupon/coupons.vue